"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = void 0;
var _encoreFoundation = require("@spotify-internal/encore-foundation");
var _index = require("../TypeList/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var List = exports.List = (0, _styledComponents["default"])(_index.TypeList).attrs({
  condensedAll: true,
  listStyleReset: true
}).withConfig({
  displayName: "List",
  componentId: "sc-vnil8g-0"
})(["flex-wrap:wrap;@media (min-width:", "){align-items:center;display:flex;justify-content:flex-start;}"], _encoreFoundation.screenSmMin);